module.exports = __webpack_public_path__ + "static/media/jomo-virtual-appartment-nft.0d625146.png";